import React from "react";
import "./HomeBanner.css";

const HomeBanner = () => {
  return (
    <>
      <div className="homeBannerContainer">
        <>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <h1 className="homeBannerTitle">
            Jadukata || It’s Name Of River In Sylhet
          </h1>
          <h3 className="homeBannerTitle2">
            A Lifestyle Blog By <br />
            <span className="homeBannerTitleName">Ariful</span>
          </h3>
        </>
      </div>
    </>
  );
};

export default HomeBanner;
